import { calculateBestDirection, getDirections, getWindowDimensions, } from './direction';
/**
 * Calculates the best position (left/top coords) for a given
 * anchor and dimensions
 *
 * ### Example (es module)
 * ```js
 * import calculateBestPosition from 'calculate-position'
 *
 * const anchor = popupAnchorElement.getBoundingClientRect()
 * const dimensions = {width: popupWidth, height: popupHeight}
 *
 * console.log(calculateBestPosition({anchor, dimensions}))
 * // => {left: 200, top: 100}
 * ```
 *
 * @param anchor - anchor position that calculations will be based of
 * @param dimensions - width/height dimensions of popup element
 * @param viewport - optional viewport rectangle (defaults to window)
 */
export const calculateBestPosition = ({ anchor, dimensions, viewport = getWindowDimensions(), }) => {
    const directions = getDirections({ anchor, dimensions });
    const direction = calculateBestDirection({
        anchor,
        dimensions,
        viewport,
        directions,
    });
    return directions[direction];
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicG9zaXRpb24uanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvbGliL3Bvc2l0aW9uLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE9BQU8sRUFDTCxzQkFBc0IsRUFDdEIsYUFBYSxFQUNiLG1CQUFtQixHQUNwQixNQUFNLGFBQWEsQ0FBQztBQUdyQjs7Ozs7Ozs7Ozs7Ozs7Ozs7O0dBa0JHO0FBQ0gsTUFBTSxDQUFDLE1BQU0scUJBQXFCLEdBQUcsQ0FBQyxFQUNwQyxNQUFNLEVBQ04sVUFBVSxFQUNWLFFBQVEsR0FBRyxtQkFBbUIsRUFBRSxHQUtqQyxFQUFTLEVBQUU7SUFDVixNQUFNLFVBQVUsR0FBRyxhQUFhLENBQUMsRUFBRSxNQUFNLEVBQUUsVUFBVSxFQUFFLENBQUMsQ0FBQztJQUV6RCxNQUFNLFNBQVMsR0FBRyxzQkFBc0IsQ0FBQztRQUN2QyxNQUFNO1FBQ04sVUFBVTtRQUNWLFFBQVE7UUFDUixVQUFVO0tBQ1gsQ0FBQyxDQUFDO0lBRUgsT0FBTyxVQUFVLENBQUMsU0FBUyxDQUFDLENBQUM7QUFDL0IsQ0FBQyxDQUFDIn0=